import React from 'react';
import { Navigate } from 'react-router-dom';

import { useAppSelector } from 'store/hook';

import UserManagement from './UserManagement';

const UserManagementRoot = () => {
  const { currentUser } = useAppSelector((state) => state.auth);

  const canViewUserManagement =
    currentUser?.isSuperuser || currentUser?.isStaff || currentUser?.feature_flags?.show_user_management;

  if (!canViewUserManagement) {
    // /companies is admin-only too - PrivateRoot knows this user's actual home page.
    return <Navigate to="/" replace />;
  }

  return <UserManagement />;
};

export default UserManagementRoot;
